import { cn } from '@sparklayer-io/spark-dash-ui/lib/styles';
import { t } from 'i18next';
import logo from '../../../assets/logo.png';
import logoDark from '../../../assets/logo-white.png';
import type { I18nPrefix } from '../../../i18n/prefix';

const PAGE = 'features:auth.pages.common' satisfies I18nPrefix;

type AuthLogoProps = {
  className?: string;
};

export function AuthLogo({ className = 'h-9 w-auto' }: AuthLogoProps) {
  return (
    // Both lockups render and the `dark` variant picks one, rather than swapping `src` from a
    // hook: the scheme is on `<html>` before the bundle parses, so CSS gets it right on first
    // paint. `className` sits on the wrapper so a caller's own responsive `hidden`/`lg:block`
    // can't collide with the light/dark toggle on the images.
    <span className={cn('inline-block', className)}>
      <img className="h-full w-auto dark:hidden" src={logo} alt={t(`${PAGE}.logo_alt`)} />
      <img className="hidden h-full w-auto dark:block" src={logoDark} alt={t(`${PAGE}.logo_alt`)} />
    </span>
  );
}
